import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { token, user, loading } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-amber-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  
  if (!token) return <Navigate to="/login" replace />;
  
  // Redirect to force password change if required (except if already on that page)
  if (user?.force_password_change && location.pathname !== "/force-password-change") {
    return <Navigate to="/force-password-change" replace />;
  }
  
  // Don't allow access to force-password-change if not required
  if (!user?.force_password_change && location.pathname === "/force-password-change") {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
